import { render, staticRenderFns } from "./HelpModel.vue?vue&type=template&id=f98df6bc&scoped=true"
import script from "./HelpModel.vue?vue&type=script&lang=js"
export * from "./HelpModel.vue?vue&type=script&lang=js"
import style0 from "./HelpModel.vue?vue&type=style&index=0&id=f98df6bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98df6bc",
  null
  
)

export default component.exports